<template>
  <div class="flex h-screen bg-background-dark text-text-light">
    <!-- Sidebar -->
    <SidebarComponent />

    <!-- Content -->
    <div class="flex-1 flex flex-col overflow-y-auto">
      <!-- Header -->
      <header class="bg-sidebar-dark text-text-light p-4 flex justify-between items-center shadow-md">
        <h1 class="text-2xl font-bold text-accent-light">Dashboard</h1>
        <button @click="logout" class="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded transition">
          Logout
        </button>
      </header>

      <!-- Main Content -->
      <main class="flex-1 p-6 space-y-8">
        <div class="p-4 bg-card-welcome rounded-lg shadow-md">
          <h2 class="text-xl font-bold text-accent-light">Bine ai venit!</h2>
          <p>Bine ai venit, <span class="font-bold">Utilizator!</span></p>
        </div>

        <!-- Roluri principale -->
        <section>
          <h3 class="text-lg font-bold text-accent-light mb-4">Roluri principale</h3>
          <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            <div v-for="role in orderedPrimaryRoles" :key="role.rol" class="p-3 bg-card-welcome rounded-md shadow-md">
              <h4 class="text-md font-semibold text-accent-light mb-2">{{ role.rol }}</h4>
              <div v-if="roleSpecificAttributes[role.rol]">
                <p v-for="attribute in roleSpecificAttributes[role.rol]" :key="attribute" class="text-sm">
                  {{ attribute }}: <span class="font-bold">{{ role[attribute] || 0 }}</span>
                </p>
              </div>
            </div>
          </div>
        </section>

        <!-- Roluri adiționale -->
        <section>
          <h3 class="text-lg font-bold text-accent-light mb-4">Roluri adiționale</h3>
          <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            <div v-for="(data, role) in additionalRoles" :key="role" class="p-3 bg-card-welcome rounded-md shadow-md">
              <h4 class="text-md font-semibold text-accent-light mb-2">{{ role }}</h4>
              <div v-if="typeof data === 'object'">
                <p v-for="(value, key) in data" :key="key" class="text-sm">
                  {{ key }}: <span class="font-bold">{{ value }}</span>
                </p>
              </div>
              <div v-else>
                <p class="text-sm">Total: <span class="font-bold">{{ data }}</span></p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <!-- Footer -->
      <FooterComponent />
    </div>
  </div>
</template>

<script>
import apiClient from "@/api/axiosInstance"; // Importăm instanța Axios configurată
import SidebarComponent from "../components/SidebarComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";

export default {
  name: "DashboardView",
  components: {
    SidebarComponent,
    FooterComponent,
  },
  data() {
    return {
      primaryRoles: [],
      additionalRoles: {},
      roleSpecificAttributes: {
        "Chestor General": ["mandate_inchise"],
        Chestor: ["mandate_inchise"],
        Comisar: ["mandate_inchise"],
        Inspector: ["control_participat", "control_organizate"],
        "Agent sef principal": [
          "rutiera_participate",
          "control_participat",
          "rutiera_organizate",
          "control_organizate",
          "regrupare",
        ],
        "Agent principal": ["rutiera_participate", "control_participat", "rutiera_organizate"],
        Agent: ["rutiera_participate", "control_participat", "isctr"],
        Cadet: ["rutiera_participate", "control_participat"],
      },
    };
  },
  computed: {
    orderedPrimaryRoles() {
      const roleOrder = [
        "Chestor General",
        "Chestor",
        "Comisar",
        "Inspector",
        "Agent sef principal",
        "Agent principal",
        "Agent",
        "Cadet",
      ];
      return [...this.primaryRoles].sort(
        (a, b) => roleOrder.indexOf(a.rol) - roleOrder.indexOf(b.rol)
      );
    },
  },
  methods: {
    async fetchPrimaryRoles() {
      try {
        // Apelăm endpoint-ul corect: prefixul "/api" este inclus, conform backend-ului
        const response = await apiClient.get("/api/roluri-principale", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        this.primaryRoles = response.data;
      } catch (error) {
        console.error("Eroare la extragerea datelor pentru rolurile principale:", error);
        alert("Nu s-au putut încărca datele pentru rolurile principale.");
      }
    },
    async fetchAdditionalRoles() {
      try {
        // Apelăm endpoint-ul corect pentru rolurile adiționale
        const response = await apiClient.get("/api/roluri-aditionale", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        this.additionalRoles = response.data;
      } catch (error) {
        console.error("Eroare la extragerea datelor pentru rolurile adiționale:", error);
        alert("Nu s-au putut încărca datele pentru rolurile adiționale.");
      }
    },
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      this.$router.push({ name: "Login" });
    },
  },
  async mounted() {
    await this.fetchPrimaryRoles();
    await this.fetchAdditionalRoles();
  },
};
</script>

<style scoped>
.bg-card-welcome {
  background-color: #1a1528;
}

.text-sm {
  font-size: 0.875rem;
}

.space-y-8>*+* {
  margin-top: 2rem;
}
</style>
